<template>
  <div>
    <!--导航栏 start-->
    <div class="main">
      <div class="main-div">
        <van-nav-bar title="交易汇总" left-text="返回" @click-left="onClickLeft" left-arrow fixed />
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.2rem">
          <!-- <van-dropdown-menu >
                <van-dropdown-item  ref="item" :title="store_name">
                     <div v-for="(bububu,index) in option1" :key="index">
                            <van-cell @click="outlet(bububu.id,bububu.store_name)" :title="bububu.store_name" is-link/>
                     </div>
                </van-dropdown-item>
          </van-dropdown-menu>-->
          <van-tabs
            class="van_tabs"
            color="rgb(0,170,238)"
            title-active-color="black"
            @click="onClick(active)"
            id="vat_tabs"
            v-model="active"
          >
            <van-tab title="日报表">
              <van-grid :column-num="3" :border="false" id="vat_grid">
                <van-grid-item text="交易时间" />
                <!-- <van-grid-item  text="门店" /> -->
                <van-grid-item text="交易笔数" />
                <van-grid-item text="交易金额" />
              </van-grid>
            </van-tab>
            <van-tab title="周报表">
              <van-grid :column-num="3" :border="false" id="vat_grid">
                <van-grid-item text="交易时间" />
                <!-- <van-grid-item  text="门店" /> -->
                <van-grid-item text="交易笔数" />
                <van-grid-item text="交易金额" />
              </van-grid>
            </van-tab>
            <van-tab title="月报表">
              <van-grid :column-num="3" :border="false" id="vat_grid">
                <van-grid-item text="交易时间" />
                <!-- <van-grid-item  text="门店" /> -->
                <van-grid-item text="交易笔数" />
                <van-grid-item text="交易金额" />
              </van-grid>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <!--内容 end-->
    <div class="content">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="(admin,index) in list" :key="index">
          <van-grid :column-num="3" :border="false">
            <van-grid-item :text="admin.date" />
            <van-grid-item :text="admin.summary_collest_count+'笔'" />
            <van-grid-item :text="admin.summary_collest+'元'" />
          </van-grid>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
// import {Toast} from 'vant';

export default {
  name: "MerchantInformation", //交易汇总
  data() {
    return {
      active: 0,
      list: [],
      option1: [],
      store_id: "",
      store_name: "",
      forms: "",
      loading: false,
      finished: false,
      page: 0,
      num: 10,
    };
  },
  methods: {
    // 左侧返回
    onClickLeft() {
      this.$router.push("/StoreHomepage");
      // this.$router.go(-1)
    },
    //初始化时默认是日报表
    daily() {
      this.forms = "day";
      console.log(this.forms);
    },
    //点击报表类型
    onClick(active) {
      if (active == "0") {
        this.forms = "day";
        this.page = 0;
        this.list = [];
        this.onLoad();
        console.log(this.forms);
      } else if (active == "1") {
        this.forms = "week";
        this.page = 0;
        this.list = [];
        this.onLoad();
        console.log(this.forms);
      } else if (active == "2") {
        this.forms = "month";
        this.page = 0;
        this.list = [];
        this.onLoad();
        console.log(this.forms);
      }
    },

    //全部门店列表
    //    theStores(){
    //              this.$http.get('/wechat/user/get_merchant_list', {
    //             params:{
    //                 merchant_id:window.sessionStorage.getItem("commercialId"),
    //             }
    //         }).then(response => {
    //             // console.log(response.data.data);
    //             this.option1=response.data.data
    //           this.number()
    //           this.page=0
    //           this.list=[]
    //           this.onLoad()

    //         })
    //    },
    //默认选择第一家门店
    number() {
      if (this.store_id == "") {
        this.store_id = this.option1[0].id;
        this.store_name = this.option1[0].store_name;
      }
    },
    //门店选择
    // outlet(a,b){
    //    this.store_id=a;
    //    this.store_name=b;
    //    console.log(a,b);
    //    this.$refs.item.toggle();
    // //    this.choose()
    //    this.page=0
    //    this.list=[]
    //    this.onLoad()

    // },

    // 触发下拉刷新更多
    onLoad() {
      this.page += 1;
      this.report();
    },
    //报表
    report() {
      var that = this;
      this.$http
        .get("/wechat/api.order/get_order_summary", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
            store_id: window.sessionStorage.getItem("store_id"),
            summary_type: this.forms,
            page: this.page,
            num: this.num,
          },
        })
        .then((response) => {
          // console.log(response.data.data);
          // this.list=response.data.data
          that.loading = false;
          if (response.data.data.length) {
            that.list.push(...response.data.data);
            that.finished = false;
          } else {
            that.finished = true;
          }
        });
    },
  },
  mounted() {
    this.daily();
    //   this.theStores()
  },
};
</script>

<style scoped>
#vat_tabs {
  font-size: 0.6rem;
  /* border: solid 2px red; */
}
#vat_grid {
  /* border: solid 1px red; */
  position: relative;
  bottom: 0.1rem;
}
.main {
  /* position: sticky;
    top: 1.22rem; */
  z-index: 1000;
  position: relative;
}
.main-div {
  position: fixed;
  top: 0;
  width: 100%;
}
.content {
  margin-top: 3.52rem;
  /* border: solid 1px red; */
}
.van_tabs {
  /* border: solid 1px red; */
  position: relative;
  bottom: 0.1rem;
}
</style>
